import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/pro-solid-svg-icons';

export const HomeIcon = () => (
    <div className="home-icon">
        <FontAwesomeIcon icon={faHome} />
    </div>
)
export default HomeIcon;




// WEBPACK FOOTER //
// ./src/components/icons/HomeIcon.js